import { useMemo } from 'react';
import { useGetOne } from 'react-admin';
import { isUndefined } from 'lodash';

import { reportTypesChoices } from '../../constants/reportTypes';
import { Attributes } from '../../utilities/reports/permissions';

const useAllowedReportTypesChoices = (matchingPermissions?: { attributes: Attributes }[]) => {
  const { data, isLoading } = useGetOne<{ id: string; accountId: string; reportTypes: string[]}>('available-reports', { id: '' });

  const choices = useMemo(() => reportTypesChoices.filter((report) => {
    const isAccountAllowed = data?.reportTypes.includes(report.id);

    const isPermissionsAllowed = !matchingPermissions
    || matchingPermissions.some(({ attributes }) => {
      if (isUndefined(attributes)) return true;

      if (Array.isArray(attributes.type)) return attributes.type.includes(report.id);
      return attributes.type === report.id;
    });

    return isAccountAllowed && isPermissionsAllowed;
  }), [data?.reportTypes, matchingPermissions]);

  return {
    allowedReportTypesChoices: choices,
    isLoading,
  };
};

export default useAllowedReportTypesChoices;
